import React from 'react';
import { PercapitaLong, PercapitaLongWhite } from 'assets/logos';
import { ILogoProps } from './PercapitaLogo.types';

export const PercapitaLogo: React.FC<ILogoProps> = ({ isWhite, height = 'auto', className }) => {
  const LogoSvgComponent = isWhite ? PercapitaLongWhite : PercapitaLong;

  return <LogoSvgComponent height={height} width={266} className={className} />;
};
